import { useMemo } from 'react';

import { BATCH_NOTIFICATION_COUNT } from '@/shared/constants/notifications';
import { useNotification } from '@/shared/hooks/useNotification';
import { CONTENT_ANNOUNCEMENTS_TEMPLATE_ID } from '@/scenarios/profiles/lib/profilesPage';
import { useNotificationViewed } from '@/shared/hooks/useNotificationViewed';
import { clientConfig } from '@/config/client';

import { transformMovieAnnouncementsNotification } from '../lib/transformMovieAnnouncementsNotification';

const { promotionConfig } = clientConfig;

export const useMovieAnnouncementsNotification = () => {
    const { notification } = useNotification({
        variables: {
            consumer: promotionConfig?.profileChoosingConsumer || '',
            platform: promotionConfig?.platform || '',
            supportedTemplateIds: [CONTENT_ANNOUNCEMENTS_TEMPLATE_ID],
            supportedTemplateToActions: {
                [CONTENT_ANNOUNCEMENTS_TEMPLATE_ID]: [],
            },
            notificationCount: BATCH_NOTIFICATION_COUNT,
        },
    });

    const transformedNotification = useMemo(
        () => transformMovieAnnouncementsNotification(notification),
        [notification]
    );

    const viewNotification = useNotificationViewed();

    if (transformedNotification) {
        const { feedbackToken, payload } = transformedNotification;
        const handleViewNotification = () => {
            viewNotification(feedbackToken);
        };

        return { notification: payload, onView: handleViewNotification };
    }

    return { notification: null, onView: undefined };
};
